import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { makeStyles } from "@material-ui/core";

// import Loading from '../../../components/Loading';
import EnhancedResetPasswordForm from "./EnhancedResetPassword";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import GridContainer from "components/MaterialKit/Grid/GridContainer.js";
import GridItem from "components/MaterialKit/Grid/GridItem.js";

import Card from "components/MaterialKit/Card/Card.js";

const useStyles = makeStyles(styles);

const ResetPassword = () => {
  const classes = useStyles();
  const history = useHistory();
  const params = useParams();
  const image = require("assets/img/main/gaming.gif");
  const token = params.resettoken;
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  setTimeout(function () {
    setCardAnimation("");
  }, 700);

  //eslint-disable-next-line
  const { loading } = useSelector((state) => {
    return {
      loading: state.auth.loading,
    };
  }, shallowEqual);

  return (
    <div
      className={classes.pageHeader}
      style={{
        backgroundImage: "url(" + image + ")",
        backgroundSize: "cover",
        backgroundPosition: "top center",
      }}
    >
      {/* {loading && <Loading />} */}
      <div className={classes.container}>
        <GridContainer
          justify="center"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <GridItem xs={12} sm={12} md={6}>
            <Card className={classes[cardAnimaton]}>
              <EnhancedResetPasswordForm history={history} token={token} />
              <br />
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default ResetPassword;
